import { logAssert } from "@faire/web--source/common/logging";
import { createContext, useContext } from "react";

import { Category } from "@faire/retailer/models/Category/Category";

export const Context = createContext<Category | undefined>(undefined);

export const LoggedOutCategoryPageCurrentCategoryProvider = Context.Provider;

export const useLoggedOutCategoryPageCurrentCategory = () => {
  const category = useContext(Context);
  logAssert(
    category !== undefined,
    "useLoggedOutCategoryPageCurrentCategory must be used within a LoggedOutCategoryPageCurrentCategoryProvider"
  );
  return category;
};
